  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
 
    import { namespace } from 'vuex-class';  
    const authStore = namespace('auth'); 
 
    @Options({
        name: "AulaPdf",
        components: {  CardRh  },   
    }) 
    export default class AulaPdf extends Vue { 
         
        @Prop( ) readonly porcentagemMin!: any  
        @Prop( ) readonly porcentagemMax!: any   
        @Prop( ) readonly status!: any   
        @Prop( ) readonly pelotao!: any   
        @Prop( ) readonly disciplinaId!: any   
        @Prop( ) readonly disciplina!: any   
        @Prop( ) readonly service!: any   

        @authStore.Getter
		public token!: any
        
        public identificador = 1 ;   
        public url: any = "";
        public modal: any = "modal_pdf_faltas_agrupadas";
        public height_w: any =  window.innerHeight;
        public height_s: any =  screen.height;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
  
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrl() + `/Relatorio/GetFaltaAgrupadas/Pdf?porcentagemMin=${this.porcentagemMin != null ? this.porcentagemMin : ''}&porcentagemMax=${this.porcentagemMax != null ? this.porcentagemMax : ''}&status=${this.status != null ? this.status : ''}&pelotao=${this.pelotao != null ? this.pelotao : ''}&disciplinaId=${this.disciplinaId != null ? this.disciplinaId : ''}    &token=${this.token}`;
                 
                this.identificador++;
            }, 2 ); 
        }

    } 
